import { useAppContext } from "context/AppContext";
import React from "react";
import { Navigate, Outlet, useParams } from "react-router-dom";

const Redirect = ({ noAuth }) => {
	const { organization } = useParams();

	const { isLoggedIn, user } = useAppContext();

	if (noAuth) {
		if (isLoggedIn && user) return <Navigate to={`/${organization}/`} />;
	} else {
		if (!isLoggedIn || !user) return <Navigate to={`/${organization}/login`} />;
	}

	return <Outlet />;
};

export default Redirect;
